import React, {PureComponent} from "react"
import {pagination, Query} from "@irati/utils/services/apollo"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import WellnessMediaListQuery, {wellnessMediaListQueryKey} from "@irati/wellness/services/queries/wellnessMediaList"
import {get} from "lodash"
import {QueryComponentProps} from "@irati/utils/services/apollo/Query"
import {WellnessMediaList} from "@irati/types"

export const query = WellnessMediaListQuery

export function getMediaList(apollo: ApolloState<{media: WellnessMediaList}>) {
  const media: WellnessMediaList = get(apollo, `data[${wellnessMediaListQueryKey}]`, {})
  const {results = [], offset, limit, count, total} = media

  return {
    results,
    offset,
    limit,
    count,
    total
  }
}

interface Props extends Omit<QueryComponentProps<{media: WellnessMediaList}>, "query"> {}

export default class WellnessMediaListComponent extends PureComponent<Props> {
  render() {
    const {children, ...props} = this.props
    return (
      <Query {...props} query={query}>
        {(apollo: ApolloState) => {
          const nextPage = (nextPageVariables: any) => pagination({query, variables: nextPageVariables}, apollo)
          return this.props.children({...apollo, nextPage})
        }}
      </Query>
    )
  }
}
